import React from "react";
import Navbar from "../components/layout/header/Navbar";
import Layout from "../components/layout/Layout";
import PageHeader from "../components/team/PageHeader";
import Footer from "../components/layout/footer/Footer";
import CabeceraBariloche from "../components/destinosSecciones/CabeceraBariloche";
import HoteleriaBariloche from "../components/hoteleria/HoteleriaBariloche";
import Transporte from "../components/Transporte/Transporte";
import VideoPromoDestino from "../components/promo/VideoPromoDestino";
import DiversionBariloche from "../components/diversion/DiversionBariloche";
import AsistenciaMedica from "../components/AsistenciaMedica/AsistenciaMedica";

export default function SecBariloche() {
    return (
      <Layout>
      <Navbar darkBg />
      <PageHeader
        background={"assets/img/bariloche/bariloche1.jpg"}
        HeaderTitle="Bariloche"
        Parent="secundarios"
        PageTitle="Bariloche"
      />
      <CabeceraBariloche destino={"Bariloche"} />
      <VideoPromoDestino
        background="assets/img/bariloche/BannervideoBRC.jpg"
        YoutubeVideoId="n41v7n1O_SA"
        TextoPromo="Conoce Bariloche, donde todos quieren estar."
      />
      <HoteleriaBariloche />
      <DiversionBariloche hasBg={true} />
      <Transporte />
      <AsistenciaMedica bgColor />
      <Footer />
    </Layout>
      );
}